
import { useLayoutEffect } from 'react';
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { initI18n } from "@/i18n";
import { GameScene } from '@/core/types/global.types';
import { useGlobalStore } from '@/store/useGlobalStore';
import { BattleUI } from '@/view/ui/battle/BattleUI';
import { WorldUI } from '@/view/ui/world/WorldUI';
import { CityHub } from '@/view/ui/city/CityHub';


await initI18n();

export const RootUI = () => {
    const currentScene = useGlobalStore((state) => state.currentScene);
    const changeScene = useGlobalStore(s => s.changeScene);
    useLayoutEffect(() => {
        changeScene(currentScene);
    }, [currentScene]);

    return (
        <I18nProvider i18n={i18n}>
            {currentScene === GameScene.WORLD && <WorldUI />}
            {currentScene === GameScene.BATTLE && <BattleUI />}
            {currentScene === GameScene.CITY && <CityHub />}
        </I18nProvider>
    );
};